import { Stack, Text } from '@mantine/core';
import { UnderlineTooltip } from 'src/UI/common';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { GroupMember, appliesToFullNames, appliesToLabel } from '../grouping';

/**
 * Members are shortened to keep the column one line wide however many share an item; the
 * tooltip carries the full names, which is the only place they can be read in full. A shared
 * item's tooltip gives each owner's part in their place, one line each.
 */
export function AppliesToCell({ members, parts }: { members: GroupMember[]; parts?: string[] }) {
  if (members.length === 0) return null;

  return (
    <UnderlineTooltip
      label={
        parts && parts.length > 0 ? (
          <Stack gap={2}>
            {/* Two owners can read alike, e.g. even shares between two members of the same name */}
            {parts.map((part, index) => (
              <Text key={index} inherit>
                {part}
              </Text>
            ))}
          </Stack>
        ) : (
          appliesToFullNames(members)
        )
      }
      multiline={!!parts?.length}
      size="xs"
      fw={FONT_WEIGHTS.medium}
      c="black"
    >
      {appliesToLabel(members)}
    </UnderlineTooltip>
  );
}
